import * as React from 'react';

import { Loader } from 'components';
import { TEXT } from 'texts';
import { getIdFromUrl } from 'utils';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

type AuthProviderProps = {};

export const AuthProvider: React.FC<React.PropsWithChildren<AuthProviderProps>> = observer(({ children }) => {
  const { appStore, authStore, errorStore } = useStores();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const setToken = async () => {
    try {
      setIsLoading(true);
      const token = await authStore.getToken();
      authStore.setToken(token);
    } catch (error) {
      errorStore.setError({ title: TEXT.error, description: (error as Error).message, callback: setToken });
    } finally {
      setIsLoading(false);
    }
  };

  const setId = () => {
    appStore.setId(getIdFromUrl(window.location.search));
  };

  React.useEffect(() => {
    setToken();
    setId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      {authStore.hasToken && children}
    </>
  );
});
